import * as yup from "yup";

import { STATES } from "../../../../constants/states";
import { yup_password_factory } from "../../../../utils/yupSchemaUtils";

export const PROVIDER_INITIAL_VALUES = {
  address: "",
  cp_credentials: "",
  mobile: "",
  name: "",
  npi_number: "",
  practice: "",
  provider_type: "",
  Username: "",
};

export const PROVIDER_VALIDATION_SCHEMA = yup.object().shape({
  address: yup.string().required("Address is required"),
  ConfirmPassword: yup
    .string()
    .required("Confirm password is required")
    .oneOf([yup.ref("Password"), null], "Password does not match"),
  cp_credentials: yup.string().required("CP credentials are required."),
  mobile: yup.string().matches(/^\d{10}$/, "Mobile Number must be a valid US number"),
  name: yup.string().required("Name is required"),
  npi_number: yup.string().matches(/^\d{10}$/, "NPI number must be 10 digits long"),
  Password: yup_password_factory(),
  provider_type: yup.string().required("Provider type is required."),
  Username: yup.string().email("Enter a valid email address").required("Email is required"),
});

export const BUILD_PROVIDER_SCHEMA = (isIdpEnabled = false) => {
  let Schema = [
    {
      elementConfig: {
        label: "Name",
        placeholder: "Name",
        type: "text",
      },
      elementType: "input",
      name: "name",
    },
    {
      elementConfig: {
        label: "Email",
        placeholder: "Email",
        type: "text",
      },
      elementType: "input",
      name: "Username",
    },
    {
      disabled: true,
      elementConfig: {
        label: "Practice",
        placeholder: "Practice",
        type: "text",
      },
      elementType: "input",
      name: "practice",
    },
    {
      elementConfig: {
        label: "CP Credentials",
        placeholder: "CP Credentials",
        type: "text",
      },
      elementType: "input",
      name: "cp_credentials",
    },
    {
      elementConfig: {
        label: "NPI Number",
        placeholder: "NPI Number",
        type: "text",
      },
      elementType: "input",
      name: "npi_number",
    },
    {
      elementConfig: {
        label: "Mobile",
        placeholder: "Mobile",
        type: "mobile",
      },
      elementType: "input",
      name: "mobile",
    },
    {
      elementConfig: {
        label: "Provider Type",
        options: [
          { display: "Primary Care Provider", value: "PCP" },
          { display: "Care Manager", value: "CARE_MANAGER" },
          { display: "Behavioral Specialist", value: "BEHAVIORAL" },
          { display: "Intake Behavioral Specialist", value: "BEHAVIORAL_INTAKE" },
          { display: "Prescriber", value: "PRESCRIBE" },
          { display: "Peer", value: "PEER" },
          { display: "Case Manager", value: "CASE_MANAGER" },
        ],
        placeholder: "Select provider type",
      },
      elementType: "select",
      name: "provider_type",
    },
    {
      elementConfig: {
        label: "Receive New Patients",
        type: "checkbox",
      },
      elementType: "input",
      name: "accept_new_patients",
    },
    {
      displayName: "Address",
      elementType: "segment",
    },
    {
      elementConfig: {
        label: "Street",
        placeholder: "Enter Street",
        type: "text",
      },
      elementType: "input",
      name: "address.street",
    },
    {
      elementConfig: {
        label: "City",
        placeholder: "Enter City",
        type: "text",
      },
      elementType: "input",
      name: "address.city",
    },
    {
      elementConfig: {
        label: "State",
        options: STATES,
        placeholder: "Enter State",
      },
      elementType: "select",
      name: "address.state",
    },
    {
      elementConfig: {
        label: "Zip",
        placeholder: "Enter zip",
        type: "text",
      },
      elementType: "input",
      name: "address.zip_code",
    },
    {
      elementConfig: {
        label: "Intake Coordinator For Practice(s)",
        options: [],
        placeholder: "Intake Coordinator For Practice(s)",
      },
      elementType: "react-select",
      name: "intake_practice_ids",
    },
  ];

  if (isIdpEnabled) {
    Schema = Schema.filter((el) => el.name !== "ConfirmPassword" && el.name !== "Password");
  }

  return Schema;
};

export const BUILD_PROVIDER_VALIDATION_SCHEMA = () => {
  let yupValidationObject = {
    address: yup.string().required("Address is required"),
    cp_credentials: yup.string().required("CP credentials are required."),
    mobile: yup.string().matches(/^\d{10}$/, "Mobile Number must be a valid US number"),
    name: yup.string().required("Name is required"),
    npi_number: yup.string().matches(/^\d{10}$/, "NPI number must be 10 digits long"),
    provider_type: yup.string().required("Provider type is required."),
    Username: yup.string().email("Enter a valid email address").required("Email is required"),
  };

  return yup.object().shape(yupValidationObject);
};
